import {
  ChangeDetectionStrategy,
  Component,
  output,
  input,
  viewChild,
  ElementRef,
  signal,
  afterRenderEffect,
  inject,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NgpInput } from 'ng-primitives/input';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ChatService } from '../services/chat.service';
import { SessionService } from '@core/services/session.service';
import { LoginButtonComponent } from '@core/components/login-button/login-button.component';
import { NgpPopover, NgpPopoverTrigger } from 'ng-primitives/popover';
import { sleep } from '@core/utils/sleep.util';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-chat-send-message',
  imports: [
    NgpInput,
    SvgIconComponent,
    FormsModule,
    NgpPopoverTrigger,
    NgpPopover,
    LoginButtonComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './chat-send-message.component.html',
  styleUrl: './chat-send-message.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex items-center justify-center flex-col gap-8',
  },
})
export class ChatSendMessageComponent {
  public readonly chatService = inject(ChatService);
  public readonly sessionService = inject(SessionService);
  private readonly toastr = inject(ToastrService);

  sendMessage = output<string>();
  disabled = input(false);

  isEmojiOpen = signal(false);
  messageRef = viewChild<ElementRef<HTMLElement>>('messageRef');
  emojiTrigger = viewChild(NgpPopoverTrigger);

  messageControl = new FormControl<string>({
    value: '',
    disabled: this.disabled(),
  });
  messageForm = new FormGroup({
    messageControl: this.messageControl,
  });

  constructor() {
    afterRenderEffect(async () => {
      const messageEl = this.messageRef()?.nativeElement;
      if (!this.isEmojiOpen() && messageEl && !this.disabled()) {
        await sleep(10);
        const input = messageEl as HTMLInputElement;
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
        input.scrollLeft = input.scrollWidth;
      }
    });
  }

  async send() {
    const message = this.messageForm.value.messageControl;
    if (!message) {
      this.toastr.error('Message should not be empty', 'Error');

      this.messageRef()?.nativeElement?.focus();
      return;
    }
    try {
      this.sendMessage.emit(message);
      this.messageForm.reset();
    } catch (error) {
      console.log('🚀 ~ ChatSendMessageComponent ~ send ~ error:', error);
    }
  }

  handleSelectEmote(key: string) {
    const message = `${(
      this.messageForm.value.messageControl ?? ''
    ).trimEnd()} :${key}: `;
    this.messageForm.controls['messageControl'].setValue(message);
    this.isEmojiOpen.set(false);
    this.emojiTrigger()?.hide();
  }
}
